import React, { useEffect, useState } from "react";

import loyaltyScheme from "../../assets/images/loyal-customer.png";
import TopHeader from "../../components/TopHeader.tsx";
import LoyaltyScheme from "../restaurantsetup/components/LoyaltyScheme/LoyaltyScheme.tsx";
import LoyaltyQr from "./LoyaltyQr.tsx";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import axios from "axios";

function LoyaltySetupPage() {
  const [menuSelection, setMenuSelection] = useState(0);
  const apiAddress = process.env.REACT_APP_SECRET;
  const restaurant = localStorage.getItem("restaurant");
  const [restaurants, setRestaurant] = React.useState([]);
  const [selectedchildRestaurant, setselectedchildRestaurant] = React.useState(
    JSON.parse(localStorage.getItem("restaurant")),
  );

  var res = JSON.parse(restaurant as string);
  const changeMenu = (value: number) => {
    setMenuSelection(value);
  };
  const handleRestaurantSelect = async (props) => {
    console.log("debug-loyalty", props);
    // console.alert("Selected restaurant: " + props.name);
    var obj = {
      id: props.id,
      name: props.name,
      ulsHLfS: props.isHomeCook,
      FMlYe6C: props.subscriptionPlanId,
    };
    localStorage.setItem("restaurant", JSON.stringify(obj));
    localStorage.setItem("restaurantChanged", "newRestaurantSeelected");

    // Broadcast the change to other tabs
    const broadcastChannel = new BroadcastChannel("storage_change_channel");
    broadcastChannel.postMessage("restaurantChanged");

    window.dispatchEvent(new Event("storage"));
    window.location.reload();
  };
  const loadDataForRestaurant = async () => {
    const restaurant = JSON.parse(localStorage.getItem("parentrestaurant"));
    axios
      .get(
        apiAddress +
          "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
          "2e528a48-2121-48bd-97d4-b6ec8865bff2" +
          "/" +
          restaurant.id,
      )
      .then((response) => {
        console.log(response.data);
        var list = [];
        response.data.map((dt, i) => {
          const isHomeCook = dt.isHomeCookToggle || false;
          let fallbackPlanId = isHomeCook ? 0 : -1;

          var obj = {
            id: dt.id,
            name: dt.name,
            address: dt.addressLine1,
            PhoneNumber: dt.phoneNumber,
            Email: dt.emailAddress,
            isHomeCook: dt.isHomeCookToggle || false,
            subscriptionPlanId: dt.subscriptionPlanId || fallbackPlanId,
          };
          list.push(obj);
        });
        setRestaurant(list);
      });
  };
  useEffect(() => {
    loadDataForRestaurant();
  }, [restaurant]);

  return (
    <div>
      <TopHeader />
      <div className="d-flex kycScroll" style={{ overflow: "scroll" }}>
        <div className="d-flex" style={{ width: "107vw" }}>
          <div>
            <div
              className="scrollable-div"
              style={{ width: "13rem", height: "100vh" }}
            >
              <div>
                <Box
                  sx={{
                    maxWidth: "180px",
                    width: "13rem",
                    marginTop: "1rem",
                    marginBottom: "1rem",
                    marginLeft: ".5rem",
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      {selectedchildRestaurant.name}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ marginLeft: "0px" }}
                      label="Restaurant Name"
                    >
                      {restaurants.map((dt, i) => {
                        return (
                          <MenuItem
                            key={i}
                            style={{ background: "none" }}
                            onClick={() => {
                              handleRestaurantSelect(dt);
                            }}
                            selected={selectedchildRestaurant.name == dt.name}
                          >
                            {dt.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Box>
              </div>
              <h6 className="ms-3 mt-2" style={{ fontSize: "13px" }}>
                <b> Setup</b>
              </h6>
              <hr style={{ margin: ".5rem" }} />

              {/* Loyalty Scheme Menu */}
              <div
                className={`loyalty_setup__menuItem ${menuSelection === 0 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(0)}
              >
                <div
                  className="d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={loyaltyScheme}
                    alt="loyalty"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Loyalty Scheme
                  </p>
                </div>
              </div>

              {/* Loyalty QR Menu */}
              <div
                className={`loyalty_setup__menuItem ${menuSelection === 1 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(1)}
              >
                <div
                  className="d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={loyaltyScheme}
                    alt="loyalty"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Loyalty QR
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="" style={{ marginLeft: "10px", width: "75%" }}>
            {menuSelection === 0 && <LoyaltyScheme />}
            {menuSelection === 1 && <LoyaltyQr />}
            {menuSelection !== 0 && menuSelection !== 1 && <p>Coming soon</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoyaltySetupPage;
